import { useLocation } from '@remix-run/react'
import { useEffect, useRef } from 'react'
import useAmplitudeContext from './use-amplitude-context'

// Adjust the import path to where your AmplitudeContext is defined

export function useTrackPageView(event: string | null = null) {
	const location = useLocation()
	const { trackAmplitudeEvent } = useAmplitudeContext()
	const previousPathnameRef = useRef<string | null>(null)

	useEffect(() => {
		// Only track if the pathname changed
		if (previousPathnameRef.current !== location.pathname) {
			trackAmplitudeEvent(event || 'Page Viewed', { path: location.pathname })
			previousPathnameRef.current = location.pathname
		}
	}, [event, location.pathname, trackAmplitudeEvent])
}
